/* eslint-disable max-len */
import { createSvgIcon } from '@mui/material/utils';

export default createSvgIcon(
  <>
    <path d="M10.5 2l1.7175 1.7175-3.66 3.66-3-3L0 9.9425 1.0575 11l4.5-4.5 3 3 4.725-4.7175L15 6.5V2zM12 16.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V21c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM12 10c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"/>
    <path opacity={0.62} d="M4 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 18.9 0 19.62 0 20.43V21c0 .55.45 1 1 1h3.5v-1.61c0-.83.23-1.61.63-2.29zM20 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V22H23c.55 0 1-.45 1-1v-.57z"/>
  </>
, 'GroupsTrendUp');
